/// <reference path="../../_references.ts"/>

module App.Questionnaire {
	import Appointment = App.Appointments.Appointment;
	import OfficeService = App.Utils.OfficeService;

	interface Window extends ng.IWindowService {
		iFrameResizer: iframeResizer.IFrameObject
	};

	export class CustomerSurveyController {
		static $inject: string[] = [
			'$q', '$sce', '$state', '$window',
			'AppointmentService', 'SelectedAppointment', 'TitleBarService', 'ToastService', 'Validations', 'OfficeService'
		];

		appointment: Appointment = null;
		url: string = null;
		textableNumber: string = null;

		loading: boolean = true;

		constructor(
			private $q: ng.IQService,
			private $sce: ng.ISCEService,
			private $state: ng.ui.IStateService,
			private $window: Window,
			private AppointmentService: App.Appointments.AppointmentService,
			private SelectedAppointment: App.Appointments.SelectedAppointment,
			private TitleBarService: App.Helpers.TitleBarService,
			private ToastService: App.Utils.ToastService,
			private validation: Validations.Validations,
			private OfficeService: OfficeService
		) {
			TitleBarService.set('Appointment');

			OfficeService.getAppointment().then(response => {
				this.setAppointment(response.data);
			})
			.catch(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					this.setAppointment(appointment);
				});
			});
		}

		setAppointment(appointment: Appointment) {
			this.appointment = appointment;
			this.url = appointment.service_request.questionnaire ? appointment.service_request.questionnaire.short_url : null;

			if (this.url === null) {
				this.AppointmentService.createSRQuestionnaire(this.appointment.service_request.id).then((response) => {
					this.url = response.data.url;
				}).catch(() => {
					this.ToastService.show('Unable to find survey.')
				});
			}
			this.textableNumber = this.SelectedAppointment.getPhone(true, true);

			if (this.textableNumber === "No phone found") {
				this.textableNumber = null;
			}

			this.loading = false;
		}

		private isIOSDevice(): boolean {
			return true;
			// Currently disabled, as fixing it for iOS devices mangles normal devices
			return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !(<any>window).MSStream);
		}

		fixIFrame(selector: string) {
			if (this.isIOSDevice()) {
				this.$window.iFrameResize({
					log: false,
					checkOrigin: false,
					tolerance: 5,
				}, selector);
			}
		}

		secureIframeSrc() {
			let seperator = this.url.indexOf('?') === -1 ? '?' : '&',
				iDevice = this.isIOSDevice() ? 1 : 0;

			return this.$sce.trustAsResourceUrl(
				this.url + seperator + 'iDevice=' + iDevice
			);
		}

		sendText() {
			this.AppointmentService.sendCustomerSRText(this.appointment.service_request.id, this.textableNumber, 'resend').then(() => {
				this.ToastService.show('Text Sent.');
			});
		}
	}
}